import { render } from "./EntryContent.vue?vue&type=template&id=38ce34b6&scoped=true"
import script from "./EntryContent.vue?vue&type=script&lang=js"
export * from "./EntryContent.vue?vue&type=script&lang=js"

import "./EntryContent.vue?vue&type=style&index=0&id=38ce34b6&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ce34b6"]])

export default __exports__